<template>
  <v-container class="containerSize">
    <v-carousel
      height="auto"
      :value="model"
      :cycle="isCycle"
      :show-arrows="showArrows"
      :hide-delimiters="hideDelimiter"
      hide-delimiter-background
      :interval="3000"
    >
      <v-carousel-item v-for="i in count" :key="`carousel-${i}`">
        <v-row justify="center">
          <v-col v-for="item in showImg(i)" :key="item" cols="auto">
            <v-img :src="item" alt="picture" height="50" eager contain />
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </v-container>
</template>

<script>
export default {
  name: 'CarouselMultiPic',
  props: {
    items: { type: Array, required: true },
    showCount: { type: Number, default: 1 },
    showArrows: { tyep: Boolean, default: false },
    hideDelimiter: { type: Boolean, default: false },
    isCycle: { type: Boolean, default: true },
    model: { type: Number, default: 0 },
    hasVideo: { type: Boolean, default: false },
  },
  data: () => ({}),
  computed: {
    count() {
      return Math.ceil(this.items.length / this.showCount);
    },
  },
  methods: {
    showImg(index) {
      // console.log(index)
      const start = (index - 1) * this.showCount;
      let end = start + this.showCount;
      if (end >= this.items.length) {
        end = this.items.length;
      }
      // let ary = this.items.slice(start, end)
      return this.items.slice(start, end);
    },
  },
};
</script>
<style>
/* @media (min-width: 480px) {
  .containerSize {
    max-width: 480px;
  }
}
@media(min-width: 768px) {
  .containerSize {
    max-width: 768px;
  }
}
@media(min-width: 992px) {
  .containerSize{
    max-width: 992px;
  }
}
@media(min-width: 1280px) {
  .containerSize{
    max-width: 1280px;
  }
}
@media(min-width: 1440px) {
  .containerSize{
    max-width: 1440px;
  }
} */
</style>
